import React from "react";
import InternalLink from "../InternalLink";
import {
    Container,
    Section,
    Columns,
    Column,
    Title,
    Heading,
} from "../../sdk/Layout";

import { Cols, Col, Text, Image, Follow } from "./style";
import Icons from "../Icons2";

function AboutUs({ config, _t }) {
    if (config == null || config.length === 0) return null;

    return (
        <Section>
            <Container>
                <Cols isMultiline>
                    <Col is4 className="is-hidden-mobile">
                        <Image>
                            <img
                                src={
                                    config[0].image &&
                                    config[0].image.img.length > 0
                                        ? `${config[0].image.img[0]}?d=400x400`
                                        : ""
                                }
                                alt=""
                            />
                        </Image>
                    </Col>
                    <Col is8>
                        <Text>
                            <Heading>
                                <h2>{config[0].title}</h2>
                            </Heading>
                            <p
                                dangerouslySetInnerHTML={{
                                    __html: config[0].paragraph,
                                }}
                            />
                        </Text>
                    </Col>
                    <Col is4>
                        <Image medium right>
                            <img
                                src={
                                    config[0].image &&
                                    config[0].image.img.length > 1
                                        ? `${config[0].image.img[1]}?d=400x400`
                                        : ""
                                }
                                alt=""
                            />
                        </Image>
                    </Col>
                    <Col is4>
                        <Image>
                            <img
                                src={
                                    config[0].image &&
                                    config[0].image.img.length > 2
                                        ? `${config[0].image.img[2]}?d=400x400`
                                        : ""
                                }
                                alt=""
                            />
                        </Image>
                    </Col>
                    <Follow is4>
                        <div>
                            <Title size="6" as="h4">
                                {_t("fallowUs")}
                            </Title>
                            {config[0].facebook ? (
                                <InternalLink {...config[0].facebook}>
                                    <Icons icon="facebook"></Icons>
                                </InternalLink>
                            ) : null}
                            {config[0].instagram ? (
                                <InternalLink {...config[0].instagram}>
                                    <Icons icon="instagram"></Icons>
                                </InternalLink>
                            ) : null}
                            {config[0].twitter ? (
                                <InternalLink {...config[0].twitter}>
                                    <Icons icon="twitter"></Icons>
                                </InternalLink>
                            ) : null}
                            {config[0].linkedin ? (
                                <InternalLink {...config[0].linkedin}>
                                    <Icons icon="linkedin"></Icons>
                                </InternalLink>
                            ) : null}
                        </div>
                    </Follow>
                </Cols>
            </Container>
        </Section>
    );
}

export default AboutUs;
